var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoChapterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.334,
    height: 13,
    viewBox: "0 0 17.334 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8e8e8e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.873,5.889A.365.365,0,0,0,6.5,6.25v6.5a.361.361,0,0,0,.6.267l3.611-3.25a.359.359,0,0,0,0-.534L7.1,5.983a.344.344,0,0,0-.23-.094Zm.35,1.17L9.933,9.5,7.222,11.941ZM1.083,3A1.089,1.089,0,0,0,0,4.083V14.917A1.089,1.089,0,0,0,1.083,16H16.25a1.089,1.089,0,0,0,1.083-1.083V4.083A1.089,1.089,0,0,0,16.25,3Zm0,.722H16.25a.352.352,0,0,1,.361.361V14.917a.352.352,0,0,1-.361.361H1.083a.352.352,0,0,1-.361-.361V4.083A.352.352,0,0,1,1.083,3.722Z",
    transform: "translate(0 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChapterIcon);
export default __webpack_public_path__ + "static/media/video-chapter-icon.1a7c59c8ce520816c725f4bc80e622ca.svg";
export { ForwardRef as ReactComponent };